import script from "./OrderEvaluateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderEvaluateDialog.vue?vue&type=script&setup=true&lang=js"

import "./OrderEvaluateDialog.vue?vue&type=style&index=0&id=5e38fbb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e38fbb2"]])

export default __exports__